<template>
  <div class="service-card-management">
    <ds-header title="服务卡片管理"></ds-header>

    <a-form layout="inline">
      <a-form-item label="卡片标题：">
        <a-input
          v-model.trim="searchForm.title"
          placeholder="请输入卡片标题"
          allow-clear
          class="inputClass"
          @pressEnter="search"
        />
      </a-form-item>
      <a-form-item label="状态：">
        <a-select
          v-model="searchForm.status"
          placeholder="全部状态"
          style="width: 200px"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in statusOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="跳转类型：">
        <a-select
          v-model="searchForm.targetType"
          placeholder="全部类型"
          style="width: 200px"
          :getPopupContainer="(triggerNode) => triggerNode.parentNode"
        >
          <a-select-option v-for="item in targetTypeOptions" :key="item.value" :value="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <span>
        <a-button type="primary" @click="search" style="margin-top: 3px">
          <a-icon type="search" />查询
        </a-button>
        <a-button style="margin-left: 15px" @click="resetSearchForm">重置</a-button>
      </span>
    </a-form>

    <div style="padding-top: 15px">
      <a-button type="primary" @click="openAddModal">
        <a-icon type="plus" />新增服务卡片
      </a-button>
    </div>

    <a-table
      :rowKey="(record, index) => record.id || index"
      :columns="table.columns"
      :data-source="table.dataInfo"
      :pagination="table.pagination.total ? table.pagination : false"
      :loading="table.loading"
      @change="pageChange"
      bordered
      style="margin-top: 15px"
    >
      <span slot="targetType" slot-scope="text">
        <a-tag v-if="getTargetTypeConfig(text)" :color="getTargetTypeConfig(text).color">
          {{ getTargetTypeConfig(text).label }}
        </a-tag>
        <span v-else>-</span>
      </span>
      <span slot="linkType" slot-scope="text">
        <a-tag v-if="getLinkTypeConfig(text)" :color="getLinkTypeConfig(text).color">
          {{ getLinkTypeConfig(text).label }}
        </a-tag>
        <span v-else>-</span>
      </span>
      <span slot="targetUrl" slot-scope="text">
        <a-tooltip v-if="text" :title="text">
          <span class="ellipsis-text">{{ text }}</span>
        </a-tooltip>
        <span v-else>-</span>
      </span>
      <span slot="status" slot-scope="text">
        <a-tag :color="text === 1 ? 'green' : 'red'">
          {{ text === 1 ? '已启用' : '已禁用' }}
        </a-tag>
      </span>
      <span slot="fixedEnabled" slot-scope="text">
        {{ text === 1 ? '是' : '否' }}
      </span>
      <span slot="sortNum" slot-scope="text, record">
        {{ record.fixedEnabled === 1 ? text : '-' }}
      </span>
      <span slot="createTime" slot-scope="text">
        <div class="time-cell">{{ formatDate(text) }}</div>
        <div class="time-cell time-sub">{{ formatTime(text) }}</div>
      </span>
      <span slot="action" slot-scope="text, record" class="action">
        <a-switch
          :checked="record.status === 1"
          @change="(checked) => handleStatusChange(record, checked)"
        />
        <a-button class="btnClass" type="link" @click="openEditModal(record)">编辑</a-button>
        <a-button class="btnClass delete-btn" type="link" @click="handleDelete(record)">删除</a-button>
      </span>
    </a-table>

    <a-modal
      :maskClosable="false"
      :title="modalTitle"
      :visible="modalVisible"
      :confirm-loading="confirmLoading"
      width="720px"
      @ok="handleModalOk"
      @cancel="handleModalCancel"
    >
      <a-spin :spinning="modalLoading">
        <a-form-model
          ref="form"
          :model="form"
          :rules="rules"
          :label-col="{ span: 6 }"
          :wrapper-col="{ span: 16 }"
        >
        <a-form-model-item label="适用项目" prop="projectIds">
          <a-select
            v-model="form.projectIds"
            mode="multiple"
            placeholder="请选择适用项目"
            allow-clear
            :filter-option="filterProjectOption"
            :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            style="width: 100%"
          >
            <a-select-option v-for="item in flatProjectList" :key="item.id" :value="item.id">
              {{ item.project_name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="卡片标题" prop="title">
          <a-input
            v-model.trim="form.title"
            placeholder="请输入卡片标题"
            :maxLength="100"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="卡片描述" prop="description">
          <a-textarea
            v-model="form.description"
            placeholder="请输入卡片描述"
            :rows="3"
            :maxLength="500"
          />
        </a-form-model-item>
        <a-form-model-item label="卡片图片">
          <div
            v-for="persona in imagePersonas"
            :key="persona.value"
            class="persona-upload-row"
          >
            <span class="persona-name">{{ persona.label }}</span>
            <a-upload
              list-type="picture-card"
              class="avatar-uploader"
              :action="IMG_API + '/oss/files'"
              :before-upload="beforeImageUpload"
              :file-list="imageFileLists[persona.value]"
              accept=".png,.jpg,.jpeg"
              @change="(info) => handleImageChange(persona.value, info)"
              @preview="handleImagePreview"
            >
              <div v-if="!(imageFileLists[persona.value] || []).length">
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
          </div>
          <p class="upload-tip">支持 jpg、png、jpeg 格式，每个客服人设可上传一张，可留空</p>
          <p v-if="legacyImage" class="legacy-tip">
            <img :src="legacyImage" class="legacy-image" alt="旧格式图片" />
            检测到旧格式卡片图片，请重新上传到对应人设位；未重新上传时将原样保留
          </p>
        </a-form-model-item>
        <a-form-model-item label="卡片服务ID" prop="cardServiceId">
          <a-input
            v-model.trim="form.cardServiceId"
            placeholder="请输入卡片服务ID"
            :maxLength="64"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="链接类型" prop="linkType">
          <a-select v-model="form.linkType" placeholder="请选择链接类型" style="width: 100%">
            <a-select-option
              v-for="item in formLinkTypeOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="跳转类型" prop="targetType">
          <a-select v-model="form.targetType" placeholder="请选择跳转类型" style="width: 100%">
            <a-select-option
              v-for="item in formTargetTypeOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="跳转地址" prop="targetUrl">
          <a-input
            v-model.trim="form.targetUrl"
            placeholder="请输入跳转地址"
            :maxLength="1000"
            allow-clear
          />
        </a-form-model-item>
        <a-form-model-item label="语义标注" prop="semanticContent">
          <a-textarea
            v-model="form.semanticContent"
            placeholder="请输入语义标注内容"
            :rows="3"
            :maxLength="1000"
          />
        </a-form-model-item>
        <a-form-model-item label="固定推荐" prop="fixedEnabled">
          <a-select v-model="form.fixedEnabled" placeholder="请选择是否固定推荐" style="width: 100%">
            <a-select-option
              v-for="item in fixedEnabledOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item v-if="form.fixedEnabled === 1" label="排序值" prop="sortNum">
          <a-input-number
            v-model="form.sortNum"
            placeholder="数值越大越靠前"
            :min="0"
            :max="9999"
            style="width: 100%"
          />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-select v-model="form.status" placeholder="请选择状态" style="width: 100%">
            <a-select-option
              v-for="item in formStatusOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-modal>

    <a-modal :visible="previewVisible" :footer="null" @cancel="previewVisible = false">
      <img alt="preview" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { IMG_API } from "@/config";
import { getServiceCardList, getServiceCardDetail, updateServiceCardStatus, addServiceCard, updateServiceCard, deleteServiceCard } from "@/api/intelligentCustomerService";
import {
  SERVICE_CARD_STATUS,
  SERVICE_CARD_TARGET_TYPE,
  SERVICE_CARD_FORM_STATUS,
  SERVICE_CARD_FORM_TARGET_TYPE,
  SERVICE_CARD_FORM_LINK_TYPE,
  SERVICE_CARD_FIXED_ENABLED,
  SERVICE_CARD_TARGET_TYPE_MAP,
  SERVICE_CARD_LINK_TYPE_MAP,
  SERVICE_CARD_IMAGE_PERSONAS,
} from "../help";

const getDefaultForm = () => ({
  id: undefined,
  projectIds: [],
  title: "",
  description: "",
  cardServiceId: "",
  linkType: 1,
  targetUrl: "",
  targetType: 1,
  semanticContent: "",
  status: 1,
  fixedEnabled: 0,
  sortNum: 0,
});

export default {
  name: "ServiceCardManagement",
  data() {
    return {
      statusOptions: SERVICE_CARD_STATUS,
      targetTypeOptions: SERVICE_CARD_TARGET_TYPE,
      formStatusOptions: SERVICE_CARD_FORM_STATUS,
      formTargetTypeOptions: SERVICE_CARD_FORM_TARGET_TYPE,
      formLinkTypeOptions: SERVICE_CARD_FORM_LINK_TYPE,
      fixedEnabledOptions: SERVICE_CARD_FIXED_ENABLED,
      imagePersonas: SERVICE_CARD_IMAGE_PERSONAS,
      imageFileLists: { "1": [], "2": [], "3": [] },
      legacyImage: "",
      searchForm: {
        title: "",
        status: "",
        targetType: "",
      },
      table: {
        loading: false,
        columns: [
          {
            title: "ID",
            dataIndex: "id",
            key: "id",
            width: 80,
          },
          {
            title: "卡片标题",
            dataIndex: "title",
            key: "title",
            ellipsis: true,
            width: 200,
          },
          {
            title: "跳转类型",
            dataIndex: "targetType",
            key: "targetType",
            width: 110,
            scopedSlots: { customRender: "targetType" },
          },
          {
            title: "链接类型",
            dataIndex: "linkType",
            key: "linkType",
            width: 130,
            scopedSlots: { customRender: "linkType" },
          },
          {
            title: "跳转地址",
            dataIndex: "targetUrl",
            key: "targetUrl",
            ellipsis: true,
            width: 100,
            scopedSlots: { customRender: "targetUrl" },
          },
          {
            title: "状态",
            dataIndex: "status",
            key: "status",
            width: 100,
            scopedSlots: { customRender: "status" },
          },
          {
            title: "固定推荐",
            dataIndex: "fixedEnabled",
            key: "fixedEnabled",
            width: 100,
            scopedSlots: { customRender: "fixedEnabled" },
          },
          {
            title: "排序值",
            dataIndex: "sortNum",
            key: "sortNum",
            width: 90,
            scopedSlots: { customRender: "sortNum" },
          },
          {
            title: "创建人",
            dataIndex: "createBy",
            key: "createBy",
            width: 100,
          },
          {
            title: "创建时间",
            dataIndex: "createTime",
            key: "createTime",
            width: 140,
            scopedSlots: { customRender: "createTime" },
          },
          {
            title: "操作",
            key: "action",
            width: 200,
            scopedSlots: { customRender: "action" },
          },
        ],
        dataInfo: [],
        pagination: {
          showSizeChanger: true,
          current: 1,
          pageSize: 10,
          total: 0,
          showQuickJumper: true,
          showTotal: (total) => `共 ${total} 条`,
        },
      },
      modalVisible: false,
      confirmLoading: false,
      modalLoading: false,
      modalType: "add",
      IMG_API,
      previewVisible: false,
      previewImage: "",
      form: getDefaultForm(),
      rules: {
        projectIds: [
          { required: true, type: "array", min: 1, message: "请选择适用项目", trigger: "change" },
        ],
        title: [
          { required: true, message: "请输入卡片标题", trigger: "blur" },
          { max: 100, message: "卡片标题最多100个字符", trigger: "blur" },
        ],
        cardServiceId: [
          { required: true, message: "请输入卡片服务ID", trigger: "blur" },
          { max: 64, message: "卡片服务ID最多64个字符", trigger: "blur" },
        ],
        linkType: [{ required: true, message: "请选择链接类型", trigger: "change" }],
        targetType: [{ required: true, message: "请选择跳转类型", trigger: "change" }],
        targetUrl: [
          { required: true, message: "请输入跳转地址", trigger: "blur" },
          { max: 1000, message: "跳转地址最多1000个字符", trigger: "blur" },
        ],
        semanticContent: [
          { required: true, message: "请输入语义标注内容", trigger: "blur" },
          { max: 1000, message: "语义标注内容最多1000个字符", trigger: "blur" },
        ],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
        fixedEnabled: [{ required: true, message: "请选择是否固定推荐", trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapState({
      projectList: (state) => state.common.projects || [],
    }),
    flatProjectList() {
      const result = [];
      const walk = (items) => {
        (items || []).forEach((item) => {
          result.push({
            id: String(item.id),
            project_name: item.project_name,
          });
          if (item.child && item.child.length) {
            walk(item.child);
          }
        });
      };
      walk(this.projectList);
      return result;
    },
    modalTitle() {
      return this.modalType === "add" ? "新增服务卡片" : "编辑服务卡片";
    },
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    isSuccess(res) {
      return res && [0, "0", 200, "200"].includes(res.code);
    },
    getTargetTypeConfig(value) {
      return SERVICE_CARD_TARGET_TYPE_MAP[value] || null;
    },
    getLinkTypeConfig(value) {
      return SERVICE_CARD_LINK_TYPE_MAP[value] || null;
    },
    formatDate(time) {
      if (!time) return "-";
      return String(time).split(" ")[0] || time;
    },
    formatTime(time) {
      if (!time) return "";
      const parts = String(time).split(" ");
      return parts[1] || "";
    },
    search() {
      this.table.pagination.current = 1;
      this.fetchList();
    },
    resetSearchForm() {
      this.table.pagination.current = 1;
      this.table.pagination.pageSize = 10;
      this.searchForm = this.$options.data.call(this).searchForm;
      this.fetchList();
    },
    pageChange(option) {
      this.table.pagination.current = option.current;
      this.table.pagination.pageSize = option.pageSize;
      this.fetchList();
    },
    filterProjectOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    resetImageSlots() {
      this.imageFileLists = { "1": [], "2": [], "3": [] };
      this.legacyImage = "";
    },
    fillImageSlots(imageList) {
      const fileLists = { "1": [], "2": [], "3": [] };
      (Array.isArray(imageList) ? imageList : []).forEach((item) => {
        if (!item || !item.value) return;
        if (this.imagePersonas.some((persona) => persona.value === item.type)) {
          fileLists[item.type] = [
            { uid: item.type, name: `image-${item.type}.png`, status: "done", url: item.value },
          ];
        } else if (item.type === "default") {
          this.legacyImage = item.value;
        }
      });
      this.imageFileLists = fileLists;
    },
    getSlotImageValue(type) {
      const file = (this.imageFileLists[type] || [])[0];
      if (!file) return "";
      return (file.response && file.response.redirect_uri) || file.url || "";
    },
    buildImageList() {
      const imageList = this.imagePersonas
        .map((persona) => ({ type: persona.value, value: this.getSlotImageValue(persona.value) }))
        .filter((item) => item.value);
      if (imageList.length) {
        return imageList;
      }
      // 三个上传位都为空时，旧格式图片（default）原样保留，后端放行回传
      return this.legacyImage ? [{ type: "default", value: this.legacyImage }] : [];
    },
    checkImages() {
      const hasUploading = this.imagePersonas.some((persona) =>
        (this.imageFileLists[persona.value] || []).some((f) => f.status === "uploading")
      );
      if (hasUploading) {
        this.$message.error("图片正在上传，请稍候再保存");
        return false;
      }
      const tooLong = this.imagePersonas.some(
        (persona) => this.getSlotImageValue(persona.value).length > 500
      );
      if (tooLong) {
        this.$message.error("图片链接不能超过500个字符");
        return false;
      }
      return true;
    },
    beforeImageUpload(file) {
      const isImage = ["image/jpeg", "image/png", "image/jpg"].includes(file.type);
      if (!isImage) {
        this.$message.error("请上传 jpg、png、jpeg 格式图片");
      }
      return isImage;
    },
    handleImageChange(type, info) {
      const { file } = info;
      // beforeUpload 拦截的不合格文件没有 status：忽略，避免顶掉槽位里已上传的图片
      if (!file.status) return;
      // 只保留有效条目（组件内部列表可能残留被拦截的文件）
      const validList = (info.fileList || []).filter((f) => f.status);
      if (file.status === "uploading") {
        // 上传期间保留旧图，失败时回退
        this.imageFileLists[type] = validList;
        return;
      }
      if (file.status === "done") {
        if (file.response && file.response.redirect_uri) {
          this.imageFileLists[type] = [Object.assign({}, file, { url: file.response.redirect_uri })];
        } else {
          this.$message.error("图片上传失败");
          this.imageFileLists[type] = [];
        }
        return;
      }
      if (file.status === "error") {
        this.$message.error("图片上传失败");
        // 回退到之前的有效图片
        this.imageFileLists[type] = validList.filter((f) => f.uid !== file.uid).slice(-1);
        return;
      }
      // removed
      this.imageFileLists[type] = validList;
    },
    async handleImagePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await this.getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    buildSavePayload() {
      const payload = {
        projectIds: this.form.projectIds.map(String),
        title: this.form.title,
        cardServiceId: this.form.cardServiceId,
        linkType: this.form.linkType,
        targetUrl: this.form.targetUrl,
        targetType: this.form.targetType,
        semanticContent: this.form.semanticContent,
        status: this.form.status,
      };
      if (this.modalType === "edit") {
        payload.id = this.form.id;
      }
      if (this.form.description) {
        payload.description = this.form.description;
      }
      const imageList = this.buildImageList();
      if (imageList.length) {
        payload.imageUrl = imageList;
      }
      if (this.form.fixedEnabled !== undefined && this.form.fixedEnabled !== null) {
        payload.fixedEnabled = this.form.fixedEnabled;
      }
      if (this.form.fixedEnabled === 1) {
        payload.sortNum = this.form.sortNum || 0;
      }
      return payload;
    },
    buildQueryParams() {
      const params = {
        pageNo: this.table.pagination.current,
        pageSize: this.table.pagination.pageSize,
      };
      if (this.searchForm.title) {
        params.title = this.searchForm.title;
      }
      if (this.searchForm.status !== "" && this.searchForm.status !== undefined) {
        params.status = this.searchForm.status;
      }
      if (this.searchForm.targetType !== "" && this.searchForm.targetType !== undefined) {
        params.targetType = this.searchForm.targetType;
      }
      return params;
    },
    async fetchList() {
      this.table.loading = true;
      try {
        const res = await getServiceCardList(this.buildQueryParams());
        if (this.isSuccess(res)) {
          this.table.dataInfo = res.data?.list || [];
          this.table.pagination.total = res.data?.total || 0;
        } else {
          this.$message.error(res?.msg || "获取列表失败");
        }
      } catch {
        this.$message.error("获取列表失败");
      } finally {
        this.table.loading = false;
      }
    },
    resetForm() {
      this.form = getDefaultForm();
      this.resetImageSlots();
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
    },
    openAddModal() {
      this.modalType = "add";
      this.resetForm();
      this.modalVisible = true;
    },
    fillFormFromDetail(data) {
      this.form = {
        id: data.id,
        projectIds: (data.projectIds || []).map(String),
        title: data.title || "",
        description: data.description || "",
        cardServiceId: data.cardServiceId || "",
        linkType: data.linkType ?? 1,
        targetUrl: data.targetUrl || "",
        targetType: data.targetType ?? 1,
        semanticContent: data.semanticContent || "",
        status: data.status ?? 1,
        fixedEnabled: data.fixedEnabled ?? 0,
        sortNum: data.sortNum || 0,
      };
      this.fillImageSlots(data.imageUrl);
    },
    async openEditModal(record) {
      this.modalType = "edit";
      this.resetForm();
      this.modalVisible = true;
      this.modalLoading = true;
      try {
        const res = await getServiceCardDetail(record.id);
        if (this.isSuccess(res) && res.data) {
          this.fillFormFromDetail(res.data);
        } else {
          this.$message.error(res?.msg || "获取详情失败");
          this.modalVisible = false;
        }
      } catch {
        this.$message.error("获取详情失败");
        this.modalVisible = false;
      } finally {
        this.modalLoading = false;
      }
    },
    handleModalCancel() {
      this.modalVisible = false;
      this.resetForm();
    },
    handleModalOk() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return;
        if (!this.checkImages()) return;
        this.confirmLoading = true;
        try {
          const isEdit = this.modalType === "edit";
          const api = isEdit ? updateServiceCard : addServiceCard;
          const res = await api(this.buildSavePayload());
          if (this.isSuccess(res)) {
            this.$message.success(res.msg || (isEdit ? "更新成功" : "创建成功"));
            this.handleModalCancel();
            if (isEdit) {
              this.fetchList();
            } else {
              this.search();
            }
          } else {
            this.$message.error(res?.msg || (isEdit ? "更新失败" : "创建失败"));
          }
        } catch {
          this.$message.error(this.modalType === "edit" ? "更新失败" : "创建失败");
        } finally {
          this.confirmLoading = false;
        }
      });
    },
    handleStatusChange(record, checked) {
      const status = checked ? 1 : 0;
      const actionText = checked ? "启用" : "禁用";
      const that = this;
      this.$confirm({
        title: `确认${actionText}该服务卡片？`,
        onOk() {
          return updateServiceCardStatus({
            id: record.id,
            status,
          }).then((res) => {
            if (that.isSuccess(res)) {
              that.$message.success(res.msg || `${actionText}成功`);
              that.fetchList();
            } else {
              that.$message.error(res?.msg || `${actionText}失败`);
            }
          }).catch(() => {
            that.$message.error(`${actionText}失败，请稍后重试`);
          });
        },
      });
    },
    handleDelete(record) {
      const that = this;
      this.$confirm({
        title: "确认删除该服务卡片？",
        onOk() {
          return deleteServiceCard(record.id).then((res) => {
            if (that.isSuccess(res)) {
              that.$message.success(res.msg || "删除成功");
              // 当前页删到最后一条时回退一页，避免停留在空页
              if (that.table.dataInfo.length === 1 && that.table.pagination.current > 1) {
                that.table.pagination.current -= 1;
              }
              that.fetchList();
            } else {
              that.$message.error(res?.msg || "删除失败");
            }
          }).catch(() => {
            that.$message.error("删除失败，请稍后重试");
          });
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.service-card-management {
  // 列宽合计较大，小屏时在表格内部横向滚动，避免撑开页面
  ::v-deep .ant-table {
    overflow-x: auto;

    table {
      min-width: 1350px;
    }
  }

  .time-cell {
    line-height: 1.4;
  }

  .time-sub {
    color: rgba(0, 0, 0, 0.45);
    font-size: 12px;
  }

  .ellipsis-text {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .action {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .delete-btn {
    color: #ff4d4f;
  }

  .upload-tip {
    margin: 0;
    font-size: 12px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.45);
  }

  .persona-upload-row {
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    .persona-name {
      width: 64px;
      flex-shrink: 0;
    }
  }

  .legacy-tip {
    display: flex;
    align-items: center;
    margin: 4px 0 0;
    font-size: 12px;
    line-height: 20px;
    color: #faad14;

    .legacy-image {
      width: 32px;
      height: 32px;
      margin-right: 8px;
      border-radius: 2px;
      object-fit: cover;
      flex-shrink: 0;
    }
  }
}

::v-deep .avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}
</style>
